import React from 'react';
import WebView from 'react-native-webview'


const cupom = () => {
    return <WebView source={{ uri: 'https://oferta.rioben.org.br/pagina-de-indicacao' }} />;
}

export default cupom;